import Vue from 'vue';
import i18n from '@/i18n'
Vue.filter('gender', function (value) {
    if (!value) return '';
    value = value.toString();
    switch (value) {
        case '10': return i18n.t('general.male');
        case '20': return i18n.t('general.female');
        default: return i18n.t('general.female') + " / " + i18n.t('general.male');
    }
});